angular.module('gym.bulkImports').factory('BulkImports', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('bulk_import');
}]);
